export default __webpack_public_path__ + "static/media/certificate1.80bdf7cd.png";